/*
 * @Author: Ryan
 * @Date: 2026-01-23
 * @Description: ROI 统计卡片模块 - 展示使用 FalcoCut 的效益
 */
import React from 'react';

import StartButton from '@/3.0/ai-avatar-generator/seo/StartButton';

import styles from './index.module.scss';

/** 统计卡片配置 */
export interface ROIStatCard {
  /** 卡片 ID */
  id: string;
  /** 标题 */
  title: string;
  /** 高亮数值 */
  value: string;
  /** 描述文本 */
  description: string;
}

export interface ROIStatsSectionProps {
  /** 模块标题 */
  title: string;
  /** 统计卡片列表 */
  cards: ROIStatCard[];
  /** CTA 按钮文本 */
  ctaText: string;
  /** CTA 跳转链接 */
  ctaUrl?: string;
  /** GTM element-name 属性值 */
  elementName?: string;
}

const ROIStatsSection: React.FC<ROIStatsSectionProps> = ({
  title,
  cards,
  ctaText,
  ctaUrl = '/ai-video-generator',
  elementName,
}) => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* 标题区域 */}
        <h2 className={styles.title}>{title}</h2>

        {/* 卡片网格 */}
        <div className={styles.grid}>
          {cards.map((card) => (
            <div key={card.id} className={styles.card}>
              <h3 className={styles.cardTitle}>{card.title}</h3>
              <div className={styles.cardValue}>{card.value}</div>
              <p className={styles.cardDescription}>{card.description}</p>
            </div>
          ))}
        </div>

        {/* CTA 按钮 */}
        <div className={styles.ctaWrapper}>
          <StartButton
            text={ctaText}
            href={ctaUrl}
            className={styles.ctaButton}
            elementName={elementName}
          />
        </div>
      </div>
    </section>
  );
};

export default ROIStatsSection;
